var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 101,
    height: 101,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M53.622.781a94.053,94.053,0,0,1-4.249,23.776L29.845,5.03A94.061,94.061,0,0,1,53.622.781Z",
    transform: "translate(45.859 1.2)",
    fill: "#ff7da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M36.944,75.065,8.919,47.041c50.632-50.628-6.994,6.994,33.42-33.42C47.714,8.245,54.963,4.741,62,2.456L81.528,21.984c-2.284,7.037-5.789,14.286-11.165,19.663C29.337,82.672,87.914,24.1,36.944,75.065Z",
    transform: "translate(13.705 3.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M41.264,22.519l-2.1,18.917L22.346,58.251l-2.1-14.714Z",
    transform: "translate(31.106 34.602)",
    fill: "#ff7da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M38.417,13.587a9.908,9.908,0,1,1-14.012,0A9.911,9.911,0,0,1,38.417,13.587Z",
    transform: "translate(33.039 16.42)",
    fill: "#94e1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M35.434,40.182l-6.3,10.509L6.709,28.27l10.509-6.3Z",
    transform: "translate(10.31 33.753)",
    fill: "#ff7da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M39.128,11.471,18.109,32.49l-14.714-2.1L20.209,13.572l18.918-2.1Z",
    transform: "translate(5.216 17.624)",
    fill: "#ff7da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M13.138,19.833a1.981,1.981,0,1,0,2.8,0A1.979,1.979,0,0,0,13.138,19.833Z",
    transform: "translate(19.294 29.581)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M37.123,85.464l5-8.332,3.11,3.11a1.982,1.982,0,0,0,.45.336l1.794,12.556a1.982,1.982,0,0,0,3.363,1.121L67.653,77.439a1.982,1.982,0,0,0,.568-1.182L70.247,58.03,81.454,46.821C86.375,41.9,90.293,35.019,93.1,26.37A95.143,95.143,0,0,0,97.446,2.03,1.982,1.982,0,0,0,95.417,0,95.18,95.18,0,0,0,71.078,4.346c-8.65,2.808-15.531,6.728-20.452,11.649L39.42,27.2,21.191,29.226a1.978,1.978,0,0,0-1.182.568L3.194,46.609a1.982,1.982,0,0,0,1.121,3.363L16.87,51.766c.244.445.265.339,3.446,3.559l-8.332,5a1.983,1.983,0,0,0-.382,3.1L34.023,85.845A1.982,1.982,0,0,0,37.123,85.464Zm13.715,3.185-1.4-9.809L65.76,62.516l-1.4,12.612ZM90.273,22.012,75.435,7.174A95.875,95.875,0,0,1,93.362,4.086,95.8,95.8,0,0,1,90.273,22.012ZM53.428,18.8c4.259-4.259,10.222-7.719,17.729-10.3l17.79,17.789C86.369,33.8,82.91,39.76,78.651,44.019L52.239,70.431,36.826,55.018a1.982,1.982,0,0,0-2.8,2.8L49.436,73.234l-2.8,2.8L21.411,50.815,41.73,30.5ZM22.319,33.089l12.614-1.4L18.608,48.011,8.8,46.609ZM23.2,58.215,39.233,74.242l-4.2,7.006L16.2,62.417Z",
    transform: "translate(4.016 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M3.383,54.324,24.024,33.683a1.981,1.981,0,0,0-2.8-2.8L.581,51.522a1.981,1.981,0,1,0,2.8,2.8Z",
    transform: "translate(0 46.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M21.143,33.09a1.982,1.982,0,0,0-2.8,0L6.1,45.325a1.982,1.982,0,0,0,2.8,2.8L21.143,35.892A1.982,1.982,0,0,0,21.143,33.09Z",
    transform: "translate(8.489 49.953)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M13.92,28.67,1.686,40.905a1.982,1.982,0,0,0,2.8,2.8L16.723,31.473a1.982,1.982,0,1,0-2.8-2.8Z",
    transform: "translate(1.698 43.162)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M41.021,30.2a11.89,11.89,0,1,0-16.816,0A11.906,11.906,0,0,0,41.021,30.2ZM27.008,16.186a7.926,7.926,0,1,1,0,11.21A7.937,7.937,0,0,1,27.008,16.186Z",
    transform: "translate(31.837 15.223)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.736333f57f9ace8236af148983f0b4c4.svg";
export { ForwardRef as ReactComponent };